import { App, View } from "@pimo/pimo-app-builder";
import { DragAndDropLayout } from "@pimo/pimo-components/src/lib/layouts/drag-and-drop-layout/drag-and-drop-layout";
import {
  PMSmallNumber,
  PMSmallNumberCardEditSchema,
  PMSmallNumberProps,
} from "@pimo/pimo-components/src/lib/pm-components";

import { TestAppState } from "../../../app";
import { getLocalizedCardCopy } from "../../../utils/get-localized-card-copy";
import {
  getItemName,
  getPluralOfItemName,
} from "../../../utils/get-plural-of-item-name";
import { getOverviewCardCopy } from "../get-card-copy";

export function addItemCountCards(
  view: View<TestAppState, DragAndDropLayout>,
  app: App<TestAppState>
): void {
  const { projectName, projectNamePlural, getCardCopy } =
    getOverviewCardCopy(app);

  const numberOfItemsComponent = view.addComponent({
    component: PMSmallNumber,
    layoutProps: {
      componentId: "numberOfItemsComponent",
      labels: ["#ofItems"],
      description: "",
      title: "",
      editSchema: PMSmallNumberCardEditSchema,
    },
  });

  numberOfItemsComponent.mapLayoutProps(({ language }) => {
    return {
      componentId: "numberOfItemsComponent",
      labels: ["#ofItems"],
      description: getCardCopy(language, "numberOfItems").description,
      title: getCardCopy(language, "numberOfItems").title,
      editSchema: PMSmallNumberCardEditSchema,
    };
  });

  numberOfItemsComponent.mapState(
    ({ overview, reportComponentValues, ...appState }) => {
      const a: PMSmallNumberProps | undefined = reportComponentValues?.[
        "numberOfItemsComponent"
      ] as PMSmallNumberProps | undefined;
      return {
        showInfoIcon: false,
        showMenuIcon: false,
        number: a?.number ?? overview?._calculated?.numberOfSubEntities ?? 0,
        description: getLocalizedCardCopy(
          appState.language || "en",
          "numberOfItems",
          {
            itemName: getItemName(
              appState.settings?.configuration?.itemName,
              appState.language || "en"
            ),
            itemNamePlural: getPluralOfItemName(
              appState.settings?.configuration?.itemName,
              appState.language || "en"
            ),
            projectName,
            projectNamePlural,
          }
        ).description,
        title:
          a?.title ??
          getLocalizedCardCopy(appState.language || "en", "numberOfItems", {
            itemName: getItemName(
              appState.settings?.configuration?.itemName,
              appState.language || "en"
            ),
            itemNamePlural: getPluralOfItemName(
              appState.settings?.configuration?.itemName,
              appState.language || "en"
            ),
            projectName,
            projectNamePlural,
          }).title,
      };
    }
  );

  const numberOfCompletedItemsComponent = view.addComponent({
    component: PMSmallNumber,
  });

  numberOfCompletedItemsComponent.mapLayoutProps(({ language }) => {
    return {
      componentId: "numberOfCompletedItemsComponent",
      labels: ["#ofItems"],
      description: getCardCopy(language, "numberOfCompletedItems").description,
      title: getCardCopy(language, "numberOfCompletedItems").title,
      editSchema: PMSmallNumberCardEditSchema,
    };
  });

  numberOfCompletedItemsComponent.mapState(
    ({ overview, reportComponentValues, ...appState }) => {
      const a: PMSmallNumberProps | undefined = reportComponentValues?.[
        "numberOfCompletedItemsComponent"
      ] as PMSmallNumberProps | undefined;
      return {
        showInfoIcon: false,
        showMenuIcon: false,
        title: getLocalizedCardCopy(
          appState.language || "en",
          "numberOfCompletedItems",
          {
            itemName: getItemName(
              appState.settings?.configuration?.itemName,
              appState.language || "en"
            ),
            itemNamePlural: getPluralOfItemName(
              appState.settings?.configuration?.itemName,
              appState.language || "en"
            ),
            projectName,
            projectNamePlural,
          }
        ).title,
        number:
          a?.number ?? overview?._calculated?.numberOfCompletedSubEntities ?? 0,
        description: getLocalizedCardCopy(
          appState.language || "en",
          "numberOfCompletedItems",
          {
            itemName: getItemName(
              appState.settings?.configuration?.itemName,
              appState.language || "en"
            ),
            itemNamePlural: getPluralOfItemName(
              appState.settings?.configuration?.itemName,
              appState.language || "en"
            ),
            projectName,
            projectNamePlural,
          }
        ).description,
      };
    }
  );
}
